// React:
import React from "react";
// MUI Components:
import { Grid, Typography, useTheme } from "@mui/material";
// Components:
import EditPasswordForm from "./edit-password-form/EditPasswordForm";

const EditPassword = () => {
  const theme = useTheme();

  return (
    <>
      <Grid item xs={12}>
        <Typography
          sx={{
            fontSize: "24px",
            color: theme.palette.text.secondary,
            mb: "8px",
            [theme.breakpoints.down("md")]: {
              fontSize: "20px",
              mb: "6px",
            },
          }}
        >
          Edit Password
        </Typography>
      </Grid>

      <Grid
        item
        xs={12}
        sx={{
          height: "calc(100% - 44px)",
          [theme.breakpoints.down("md")]: {
            height: "calc(100% - 36px)",
          },
        }}
      >
        <EditPasswordForm />
      </Grid>
    </>
  );
};

export default EditPassword;
